import { Expose } from 'class-transformer'

export default class LeadAvailabilityCheckFormError {
  lead_id: string[] = []
  date: string[] = []
  start_time: string[] = []
  end_time: string[] = []
  lunch_break: string[] = []
  role: string[] = []
  postcode: string[] = []
  lat: string[] = []
  lng: string[] = []
  sedation_required: string[] = []
  radiography_required: string[] = []
  implant_required: string[] = []
  orthodontics_required: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}
